import React, { Component,Fragment } from 'react';
import { Button, Row, Col} from 'reactstrap';
import { fetchOrderDetails } from '../../store/actions/orderActions';
import { orderStatus, number_format,utcDateFormat } from '../../store/actions/UtilsOperation';
import { connect } from 'react-redux';
import { resetDataDetailsOrder } from '../../store/actions/orderActions';
import { isPickUp } from '../../store/actions/UtilsOperation';
import {MASK_STATUS, MASK_AGENT, WAITING_PAYMENT,IS_DIGITAL } from '../../constants/bitwiseOperations';
import { Link } from 'react-router-dom';
import {
	COMPANY_ACCESS,
	GEO_DECIMAL_PLACES
} from '../../constants/general';
import ModalBase from '../Plugins/MainModals/ModalBase';
import ModalDiscount from './ModalDiscount';

class ModalOrder extends Component {
	constructor(props, context) {
        super(props);
		this.state = {
			showDeliveryFeeDetails: false,
			showServiceFeeDetails: false,
			showDiscountDetails: false,
			showTaxDetails: false,
			showCashbackDetails: false,
			showAdjustDetails: false,
			couponDetails: {}
		}

		this.modalRef = React.createRef();

    }
	componentDidMount(){
		if (this.props.orderID) {
			this.props.fetchOrderDetails(this.props.orderID);
		}
	}

	open_modal_discounts=(id,modal,tax)=> {
        this.setState({
            [modal]:id,
			couponDetails: tax.coupon
        })
        this.modalRef.current.toggleModal();
    }

    onChange = (target) => {
    	let { name, value } = target,
			data = {
				'name': name,
				'data': value
			};
	    this.props.toggleData(data);
    }
    componentWillUnmount(){
		if(window.location.href.indexOf("order-management") !== -1 && parseInt(window.location.href.split("/").pop(),10) ){

		}else{
			this.props.resetDataDetailsOrder();
		}
  	}

	handleShowDeliveryFees = () =>{
		this.setState((prevState) => ({
			showDeliveryFeeDetails: !prevState.showDeliveryFeeDetails
		}))
	}

	handleShowServiceFees = () =>{
		this.setState((prevState) => ({
			showServiceFeeDetails: !prevState.showServiceFeeDetails
		}))
	}

	handleShowDiscountFees = () =>{
		this.setState((prevState) => ({
			showDiscountDetails: !prevState.showDiscountDetails
		}))
	}

	handleShowTaxFees = () =>{
		this.setState((prevState) => ({
			showTaxDetails: !prevState.showTaxDetails
		}))
	}

	handleShowCashbackFees = () =>{
		this.setState((prevState) => ({
			showCashbackDetails: !prevState.showCashbackDetails
		}))
	}

	handleShowAdjustFees = () =>{
		this.setState((prevState) => ({
			showAdjustDetails: !prevState.showAdjustDetails
		}))
	}

  	calculatetotalPayment = (totalOrder,discount)=>{
		var successPayment = 0;
		if(this.props.payment_form && this.props.payment_form.length > 0){

			var allPayments= [...this.props.payment_form]
			allPayments.map( (payment, j) => {
				var ordenStatus = parseInt(payment.options,10)&MASK_STATUS
				if((parseInt(payment.options,10)&MASK_AGENT) === WAITING_PAYMENT){
					if(ordenStatus >= 10){
						successPayment=successPayment+payment.total_e2
					}
				}else{
					if(ordenStatus >= 10){
						successPayment=successPayment+payment.total_e2
					}
				}
				return successPayment
			})

		}

		return <Fragment>
				{
					successPayment?
					<h6 className="text-primary mb-0">
						<b>Total pagado: </b>
						<span className="float-right">
							<b>{this.props.currency} </b>{ number_format( successPayment/100 ) }
						</span>
					</h6>
					:null
				}
				<h6 className="mb-0">
					<b>Total a pagar: </b>
					<span className="float-right">
						<b>{this.props.currency} </b>{ number_format( (totalOrder-successPayment)/100 ) }
					</span>
				</h6>
		</Fragment>
	}

   	render () {

		const orderTaxes = this.props.orderDetails.taxes ? this.props.orderDetails.taxes : [];

		const totalAmountDelivery = orderTaxes
			? orderTaxes.reduce((acc, tax) => {
				if (tax.name === 'delivery_fee') {
					acc += tax.value_e2;
				}
				return acc;
				}, 0)
			: 0;

		const totalAmountService = orderTaxes
			? orderTaxes.reduce((acc, tax) => {
				if(tax.name === 'service_fee') {
					acc += tax.value_e2;
				}
				return acc;
			  }, 0)
			: 0;

		const totalAmountDiscount = orderTaxes
			? orderTaxes.reduce((acc, tax) => {
				if(tax.name === 'discount') {
					acc += tax.value_e2;
				}
				return acc;
			  }, 0)
			: 0;

		const totalAmountTax = orderTaxes
			? orderTaxes.reduce((acc, tax) => {
				if(tax.name === 'tax') {
					acc += tax.value_e2;
				}
				return acc;
			  }, 0)
			: 0;

		const totalAmountCashback = orderTaxes
			? orderTaxes.reduce((acc, tax) => {
				if(tax.name === 'cashback') {
					acc += tax.value_e2;
				}
				return acc;
			  }, 0)
			: 0;

		const totalAmountAdjust = orderTaxes
			? orderTaxes.reduce((acc, tax) => {
				if(tax.name === 'adjust') {
					acc += tax.value_e2;
				}
				return acc;
			  }, 0)
			: 0;

		const deliveryFees = orderTaxes
			? orderTaxes.filter((tax) => tax.name === 'delivery_fee')
			: [];


		const serviceFees = orderTaxes
			? orderTaxes.filter((tax) => tax.name === 'service_details')
			: [];

		const paymentFee = orderTaxes
			? orderTaxes.filter((tax) => tax.name === 'payment_fee')
			: [];

		const taxDiscount = orderTaxes
			? orderTaxes.filter((tax) => tax.name === 'discount')
			: [];

		const taxTax = orderTaxes
			? orderTaxes.filter((tax) => tax.name === 'tax')
			: [];

		const taxCashback = orderTaxes
			? orderTaxes.filter((tax) => tax.name === 'cashback')
			: [];

		const taxAdjust = orderTaxes
			? orderTaxes.filter((tax) => tax.name === 'adjust')
			: [];



   		var discount = 0;
   		discount= this.props.orderDetails && this.props.orderDetails.taxes && this.props.orderDetails.taxes.length>0 && this.props.orderDetails.taxes.filter ( (tax, key) => {
			return tax.desc && tax.coupon && (tax.coupon.applies_to === 'subtotal' || tax.coupon.applies_to === 'base_price') && tax.value_e2;
		});

   		//let status;
   		let order_distance;
		if(this.props.orderDetails && this.props.orderDetails.status){
			var OrderIsPickUp = isPickUp(this.props.orderDetails.client_latitude_e6, this.props.orderDetails.client_longitude_e6, this.props.orderDetails.client_address )
			//? no se usa: status = orderStatus(this.props.orderDetails.status,!OrderIsPickUp)
			order_distance = this.props.orderDetails.order_providers.map((order_provider, key) => {
				return <div key={key}>
					<i className="fa fa-motorcycle"></i>
					{` Distancia recorrida por el rider: `}
					<b>
						{ `${number_format(order_provider.tracking_statistics.branch_order_distance/1000,0)} Km` }
					</b>
				</div>
			})
		}
		let asigned_provider=[]
		if(this.props.orderDetails.providers && this.props.orderDetails.providers && this.props.orderDetails.providers.length > 0){
			asigned_provider= this.props.orderDetails.providers.filter( (provider) => { return ( provider.pivot.unassigned_at === null ) })
		}

		return <Fragment>
			<ModalBase ref={ this.modalRef }
				title={`Detalles del cupón`}
				html={<ModalDiscount coupon={this.state.couponDetails} dontClearData={true} clear={true} currency={this.props.currency} reference={ ()=> this.open_modal_discounts(0,`modalDiscount`,this.state.couponDetails) } />}
			/>
			{
				this.props.orderDetails && this.props.orderDetails.status ?
					<ul className='list-group'>
						{/*

						<li className="justify-content-between list-group-item">
							{this.props.json_lang.modal_order.status_title}
							{
								this.props.orderDetails && this.props.orderDetails.status?
									<span className="float-right"> <span className={status.style}>{status.text}</span></span>
								:
									null
							}

						</li>
						 */}
						{/*<li className="justify-content-between list-group-item">
							{this.props.json_lang.table_orders.is_pickup_label}:
							<h5 className="mb-0 float-right">
								<Badge color={OrderIsPickUp ? "success":"info"}>
									{OrderIsPickUp ? this.props.json_lang.common.pickup : this.props.json_lang.common.delivery}
								</Badge>
							</h5>
						</li>*/}
						{
							this.props.orderDetails.scheduled_at?
							<li className="justify-content-between list-group-item">
								{this.props.json_lang.modal_order.scheduled_at}
								<span className="float-right"> { utcDateFormat(this.props.orderDetails.scheduled_at,'DD-MM-YYYY h:mm a') }</span>
							</li>
							:null
						}

						<li className="justify-content-between list-group-item">
							{this.props.json_lang.common.client} {this.props.orderDetails.client.uuid && <span>#{this.props.orderDetails.client.uuid}</span>}<br/>
							<div className="py-3 mr-3 float-left">

                                <img ref={ 'client' }  onError={ ()=>this.refs[`client`].src= 'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png' } className="avatar_small" src={ this.props.orderDetails.client && this.props.orderDetails.client.avatar_url ? this.props.orderDetails.client.avatar_url : 'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png' }
                                	alt={ this.props.orderDetails.client && this.props.orderDetails.client.email ? this.props.orderDetails.client.email  : '' } />
                                <span className="avatar-status badge-success"></span>

                            </div>
                            <div>
	                            <strong>
	                            	{
	                            		this.props.orderDetails.client && this.props.orderDetails.client.name ?
	                            		`${this.props.orderDetails.client.name}

	                            		`
	                            		:null
	                            	}
	                            </strong>
                            </div>

                            <small className="">
                            	<b>CI:</b> {this.props.orderDetails.client.dni ? this.props.orderDetails.client.dni:`No registrado`} <br />
                                <i>@</i> {this.props.orderDetails.client && this.props.orderDetails.client.email ? this.props.orderDetails.client.email : '--' }<br/>

								{
									this.props.isZupperAdmind === true ?
										<Fragment>
											<i className="icon-phone"></i> {this.props.orderDetails.client && this.props.orderDetails.client.phone ? this.props.orderDetails.client.phone : '--' } <br/>
										</Fragment>
									:null
								}

								{this.props.orderDetails.client_address ? <Fragment><i className="icon-location-pin"></i>{this.props.orderDetails.client_address}<br /></Fragment> : null}<br />

								{
										this.props.orderDetails.is_gift === true && ((this.props.orderDetails.status&IS_DIGITAL)===0)?
										<strong className="text-muted mt-2 w-100">
											<b>Enviado como regalo a: </b>{this.props.orderDetails.receiver_name} <br />
											{this.props.orderDetails.receiver_phone && <Fragment><i className="icon-phone"></i> &nbsp;{this.props.orderDetails.receiver_phone }</Fragment> }
										</strong>
									: null
								}

								<Button size="sm" tag="a" target="_blank" className="pull-right" color="info" href={ `https://www.google.com/maps/search/?api=1&query=${this.props.orderDetails.client_latitude_e6 / GEO_DECIMAL_PLACES},${this.props.orderDetails.client_longitude_e6 / GEO_DECIMAL_PLACES}`} >Ver en mapa</Button>

                            </small>



						</li>
						{asigned_provider && asigned_provider.length > 0?
							<li className="justify-content-between list-group-item">
								{this.props.json_lang.common.provider}<br/>
								<div className="py-3 mr-3 float-left">

							        <img ref={ 'provider' }  onError={ ()=>this.refs[`provider`].src= ' https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar_rider-48x48.jpg' } className="avatar_small" src={ asigned_provider[0].avatar_url ? asigned_provider[0].avatar_url : ' https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar_rider-48x48.jpg' }
							        	alt={ asigned_provider[0].email ? asigned_provider[0].email  : '' } />
							        <span className="avatar-status badge-success"></span>

							    </div>

							    <div><strong>{asigned_provider[0].name} </strong> </div>

							    <small className="text-muted">
							        <i>@</i> {asigned_provider[0].email ? asigned_provider[0].email : '--' }<br/>
							        <i className="icon-phone"></i> { asigned_provider[0].phone ? asigned_provider[0].phone : '--' }
							        {order_distance}
							    </small>

							</li>
							:null
						}

						<li className="justify-content-between list-group-item">
							{this.props.json_lang.common.goods}
							<Row className={'mr-0 ml-0 pt-1'}>
		                        <Col className="text-center" style={{maxWidth: 120}}><b>{this.props.json_lang.create_order.quantity}</b></Col>
		                        <Col className="text-center"><b>{this.props.json_lang.common.good}</b></Col>
		                        <Col className="text-center" style={{maxWidth: 120}}><b>{this.props.json_lang.common.price}</b></Col>
		                    </Row>
							<ul style={{maxHeight: '200px',overflowY: 'auto'}}>
								{
									this.props.orderDetails.ordered_goods?
										this.props.orderDetails.ordered_goods.map( (good, key) => {
											return <li key={ key } className={ 'pl-3 pr-3 custom_detail_orden ' }>
												<div className={ 'line_item_detail_orden text-center' } style={{width:90}}>
													<h5 className="mb-0">{good.quantity}x</h5>
												</div>
												<div className={ 'line_item_detail_orden' } style={{width:`calc(100% - 90px)`}}>
													<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
														<b style={{display: 'inline-block',maxWidth: '83%'}}>{ good.name } ({good.sku || "N/A"})
															{
																good.name.toLowerCase().includes('combo') ?
																<small className='text-muted' style={{ display: 'block'}}>{good.details}</small>
																:null
															}
															{
																good.notes ?
																<div className='highlighted-notes'>
																	{good.notes}
																</div>
																:null
															}
														</b>
														<span>
															{/*
															TODO tuve que divirlo por la cantidad de productos, ya que el base_price_e2 es el mismo que el total_price_e2, por eso tambien cambie a total_price_e2 por si algun dia se solventa el problema.
															*/}
															<b>{this.props.currency} </b>{ number_format( (good.total_price_e2/100) / good.quantity ) }
														</span>
													</div>
													{
														good.properties && good.properties.length> 0?
														<ul>
															{
																good.properties.map( (property, i) => {
																	return <li key={ i } >
																		<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
																			<span className={'text-muted'}>- {property.name}: {property.value }</span>
																			<span>
																				{/* `${property.price_e2/100} x ${good.quantity} ` */}
																				<b>{this.props.currency} </b>{ number_format( (property.price_e2/100) ) }
																			</span>
																		</div>
																		{
																			property.notes ?
																			<span>
																				{property.notes}
																			</span>
																			:null
																		}

																	</li>
																})
															}
														</ul>
														:null
													}
												</div>
											</li>
										})
									:null
								}
							</ul>
						</li>
						{
							this.props.orderDetails.notes?
							<li className="justify-content-between list-group-item">
								{this.props.json_lang.modal_order.notes} <br/>
								{this.props.orderDetails.notes	}
							</li>
							:null
						}

						{
							(this.props.admin_type_id === 2 || this.props.userHigherAccess === COMPANY_ACCESS) || discount.length >0 ? <li className="justify-content-between list-group-item">
								{this.props.json_lang.common.subtotal} :
								<span className="float-right">
								<b>{this.props.currency}</b> { number_format( (this.props.orderDetails.subtotal_e2 )/100 ) } </span>
							</li>
							:null
						}

						{
							(this.props.admin_type_id === 2 || this.props.userHigherAccess === COMPANY_ACCESS) && this.props.orderDetails.taxes ?
							<Fragment>
								{
									deliveryFees.length > 0 ?
										<React.Fragment>
											<li className="justify-content-between list-group-item" type="button" onClick={this.handleShowDeliveryFees}>
												<small><i className={this.state.showDeliveryFeeDetails ? `icon-minus mr-2` : `icon-plus mr-2`} style={{color: 'green'}} /></small>
												<b>{this.props.json_lang.payments.delivery_fee}:</b>
												<span className="float-right">
													{number_format(totalAmountDelivery / 100)}
												</span>
											</li>
												{
													deliveryFees.map((tax, key) => {
														if(this.state.showDeliveryFeeDetails){
															return <li className="justify-content-between list-group-item" key={key}>
																<small className='ml-5'>{tax.desc ? tax.desc : this.props.json_lang.payments.delivery_details_fee}</small>
																<span className="float-right">
																	{number_format(tax.value_e2 / 100)}
																</span>
															</li>
														}
													})
												}
										</React.Fragment>
									:null
								}
								{
									serviceFees.length > 0 ?
										<React.Fragment>
											<li className="justify-content-between list-group-item" type="button" onClick={this.handleShowServiceFees}>
												<small><i className={this.state.showServiceFeeDetails ? `icon-minus mr-2` : `icon-plus mr-2`} style={{color: 'green'}} /></small>
												<b>{this.props.json_lang.payments.service_fee}:</b>
												<span className="float-right">
													{number_format(totalAmountService / 100)}
												</span>
											</li>
												{
													serviceFees.map((tax, key) => {
														if(this.state.showServiceFeeDetails){
															return <li className="justify-content-between list-group-item" key={key}>
																<small className='ml-5'>{tax.desc ? tax.desc : this.props.json_lang.payments.service_fee}</small>
																<span className="float-right">
																	{number_format(tax.value_e2 / 100)}
																</span>
															</li>
														}
													})
												}
										</React.Fragment>
									:null
								}
								{
									paymentFee.length > 0 ?
										paymentFee.map((tax, key) => (
											<li className="justify-content-between list-group-item" key={key}>
												<b className=' ml-5'>{tax.desc ? tax.desc : this.props.json_lang.payments.payment_fee}</b>
												<span className="float-right">
													{number_format(tax.value_e2 / 100)}
												</span>
											</li>
										))
									:null
								}
								{
									taxDiscount.length > 0 ?
										<React.Fragment>
											<li className="justify-content-between list-group-item" type="button" onClick={this.handleShowDiscountFees}>
												<small><i className={this.state.showDiscountDetails ? `icon-minus mr-2` : `icon-plus mr-2`} style={{color: 'green'}} /></small>
												<b>{this.props.json_lang.payments.discount}:</b>
												<span className="float-right">
													{number_format(totalAmountDiscount / 100)}
												</span>
											</li>
												{
													taxDiscount.map((tax, key) => {
														if(this.state.showDiscountDetails){

															return <li className="justify-content-between list-group-item" key={key}>
																<small
																	className='ml-5 text-info'
																	style={{ cursor: "pointer" }}
																	onClick={(e) => {
																		e.stopPropagation();
																		e.preventDefault();
																		this.open_modal_discounts(0,'modalDiscount',tax);
																}}>{tax.desc ? tax.desc : this.props.json_lang.payments.discount}</small>
																<span className="float-right">
																	{number_format(tax.value_e2 / 100)}
																</span>
															</li>
														}
													})
												}
										</React.Fragment>
									:null
								}
								{
									taxCashback.length > 0 && totalAmountCashback !== 0 ?
										<React.Fragment>
											<li className="justify-content-between list-group-item" type="button" onClick={this.handleShowCashbackFees}>
												<small><i className={this.state.showCashbackDetails ? `icon-minus mr-2` : `icon-plus mr-2`} style={{color: 'green'}} /></small>
												<b className="text-danger">Cashback:</b>
												<span className="float-right text-danger">
													{number_format(totalAmountCashback / 100)}
												</span>
											</li>
											{
												taxCashback.map((tax, key) => {
													if(this.state.showCashbackDetails){

														return <li className="justify-content-between list-group-item" key={key}>
															<small
																className='ml-5 text-info'
																style={{ cursor: "pointer" }}
																onClick={(e) => {
																	e.stopPropagation();
																	e.preventDefault();
																	this.open_modal_discounts(0,'modalDiscount',tax);
															}}>
																{tax.desc ? tax.desc : 'Cashback'}
															</small>
															<span className="float-right">
																{number_format(tax.value_e2 / 100)}
															</span>
														</li>
													}
												})
											}
										</React.Fragment>
									:null
								}
								{
									taxTax.length > 0 ?
										<React.Fragment>
											<li className="justify-content-between list-group-item" type="button" onClick={this.handleShowTaxFees}>
												<small><i className={this.state.showTaxDetails ? `icon-minus mr-2` : `icon-plus mr-2`} style={{color: 'green'}} /></small>
												<b>{this.props.json_lang.payments.taxes}:</b>
												<span className="float-right">
													{number_format(totalAmountTax / 100)}
												</span>
											</li>
												{
													taxTax.map((tax, key) => {
														if(this.state.showTaxDetails){
															return <li className="justify-content-between list-group-item" key={key}>
																<small className='ml-5'>{tax.desc ? tax.desc : this.props.json_lang.payments.taxes}</small>
																<span className="float-right">
																	{number_format(tax.value_e2 / 100)}
																</span>
															</li>
														}
													})
												}
										</React.Fragment>
									:null
								}
								{
									taxAdjust.length > 0 && totalAmountAdjust !== 0 ?
										<React.Fragment>
											<li className="justify-content-between list-group-item" type="button" onClick={this.handleShowAdjustFees}>
												<small><i className={this.state.showAdjustDetails ? `icon-minus mr-2` : `icon-plus mr-2`} style={{color: 'green'}} /></small>
												<b>{this.props.json_lang.payments.adjust}:</b>
												<span className="float-right">
													{number_format(totalAmountAdjust / 100)}
												</span>
											</li>
												{
													taxAdjust.map((tax, key) => {
														if(this.state.showAdjustDetails){

															return <li className="justify-content-between list-group-item" key={key}>
																<small className='ml-5'>{tax.desc ? tax.desc : this.props.json_lang.payments.adjust}</small>
																<span className="float-right">
																	{number_format(tax.value_e2 / 100)}
																</span>
															</li>
														}
													})
												}
										</React.Fragment>
									:null
								}
							</Fragment>
							: <Fragment>
								{
									this.props.orderDetails.taxes.map( (tax, key) => {
										return tax.desc && tax.coupon && (tax.coupon.applies_to === 'subtotal' || tax.coupon.applies_to === 'base_price') && <li key={key} className="justify-content-between list-group-item">
											{this.props.json_lang.payments[tax.name]}:
											<span className="float-right">
												<b>{this.props.currency}</b> {number_format(tax.value_e2 / 100)}
											</span>
											{tax.desc &&<small className={`w-100`}>{tax.desc}</small>}
										</li>
									})

								}
							</Fragment>
						}
						{/* {
							(this.props.admin_type_id !== 2 || this.props.userHigherAccess !== COMPANY_ACCESS) && discount.length >0 ?
							<li className="justify-content-between list-group-item">
								{this.props.json_lang.common.total} :
								<span className="float-right">
								<b>{this.props.currency}</b> { number_format( (this.props.orderDetails.total_e2+discount[0].value_e2 )/100 ) } </span>
							</li>
							:<li className="justify-content-between list-group-item">
								{this.props.json_lang.common.total} :
								<span className="float-right">
								<b>{this.props.currency}</b> { number_format( this.props.orderDetails.total_e2/100 ) } </span>
							</li>
						} */}

						<li className="justify-content-between list-group-item">
							{this.calculatetotalPayment( this.props.orderDetails.total_e2,(discount && discount[0] ? discount[0].value_e2:0))}
						</li>

						<li className="text-center list-group-item">

							<Link color="info w-100" to={'/order-management/'+this.props.orderDetails.id }>
								<b>{this.props.json_lang.common.more}</b>
							</Link>

							{/*<button className="btn btn-outline-info" onClick={(e) => this.goDetails(e)}>
								<b>{this.props.json_lang.common.more}</b>
							</button>*/}
						</li>
					</ul>
				:null
			}
		</Fragment>
	}
}

const mapStateToProps = (state) => {

	let oDetailsTaxes = state.orderDetails.taxes.filter( (tax, key) => {
		return tax.name !== 'payment_fee'
	})
	state.orderDetails.taxes =  oDetailsTaxes
	let isZupperAdmind = false;
	if(state.session && state.session.accesses.length > 0){
		isZupperAdmind = state.session && state.session.accesses.some($0 => $0.access_type === 'company')
	}
	return {
		errors: state.errors,
		orderDetails: state.orderDetails,
		json_lang: state.json_lang,
		isZupperAdmind:isZupperAdmind,
		currency: state.currencies.local.symbol,
		userHigherAccess:state.userHigherAccess,
		admin_type:state.session && state.session.admin_type && state.session.admin_type,
		session:state.session
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchOrderDetails: (id) => dispatch(fetchOrderDetails(id)),
		resetDataDetailsOrder: () => dispatch(resetDataDetailsOrder()),
		//orderStatus: (status) => dispatch(orderStatus(status)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrder);



// WEBPACK FOOTER //
// ./src/views/Orders/modalOrder.jsx